<style scoped>
a {
  text-decoration: none;
}
</style>

<template>
  <v-toolbar color="white" :fixed="true" :scroll-off-screen="true">
    <v-toolbar-title>
      <img
        src="https://cdn.evidentscientific.com/cdn/img/logo/evident-logo.svg"
      />
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn v-if="isAuthenticated" flat color="grey" to="/">
        <v-icon>home</v-icon>
        Home
      </v-btn>

      <menu-item v-if="isAuthenticated" title="New Order" icon="shop_two">
        <menu-sub-item
          title="Table to Basket"
          icon="shopping_basket"
          to="/table_to_basket"
        ></menu-sub-item>
        <menu-sub-item
          title="Search"
          icon="search"
          to="/search"
        ></menu-sub-item>
      </menu-item>

      <v-btn v-if="isAuthenticated" flat color="grey" to="/basket">
        <v-badge color="primary" left overlap :value="itemCount">
          <template v-slot:badge>
            <span>{{ itemCount }}</span>
          </template>
          <v-icon>shopping_basket</v-icon>
          Basket
        </v-badge>
      </v-btn>

      <menu-item v-if="isAuthenticated" title="Account" icon="account_circle">
        <menu-sub-item
          title="Order Status"
          icon="local_shipping"
          to="/order_status"
        ></menu-sub-item>
        <menu-sub-item
          title="Address Book"
          icon="book"
          to="/address"
        ></menu-sub-item>
        <menu-sub-item
          title="Change Email"
          icon="email"
          to="/change-email"
        ></menu-sub-item>
        <menu-sub-item
          title="Change Password"
          icon="vpn_key"
          to="/password"
        ></menu-sub-item>
        <menu-sub-action
          title="Logout"
          icon="lock"
          @click="userSignOut"
        ></menu-sub-action>
      </menu-item>

      <menu-item
        v-if="isAuthenticated && isAdmin"
        title="Admin"
        icon="headset_mic"
      >
        <menu-sub-item
          title="Customers"
          icon="people"
          to="/customer"
        ></menu-sub-item>
        <menu-sub-item
          title="Resend Order"
          icon="send"
          to="/resend_order"
        ></menu-sub-item>
      </menu-item>

      <v-btn v-if="!isAuthenticated" flat color="grey" to="/login">
        <v-icon>lock_open</v-icon>
        Log in
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MenuItem from "@/components/MenuItem";
import MenuSubItem from "@/components/MenuSubItem";
import MenuSubAction from "@/components/MenuSubAction";

export default {
  components: {
    MenuItem,
    MenuSubItem,
    MenuSubAction
  },
  computed: {
    ...mapGetters("basket", ["itemCount"]),
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("user", ["isAdmin"]),
    ...mapGetters("admin", { isMaintenance: "getIsMaintenance" })
  },
  methods: mapActions("auth", ["userSignOut"])
};
</script>
